import React, { Component } from 'react';
import {getGranelPedidos} from '../api.js';
import ContentBox from './ContentBox.js';
import ClientSelectGranel from './ClientSelectGranel';

import {urls} from '../config.js';
import TagManager from 'react-gtm-module';
import ModalCampain from "./ModalCampain"
import PopupPedidoAnular from './PopupPedidoAnularGranel';
import PopupPedidoReclamo from './PopupPedidoReclamo';
import moment from 'moment';
import {Link, Route, Switch} from "react-router-dom";
import ServiciosGranelPedido from './ServiciosGranelPedido';


export default class ServiciosGranelPedidos extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchType: "days",
			searchPedido: "",
			filterDays: "30",
			modal:{
				show:false, 
				code: null
			},
			loading: true,
			loaded: true
		};
	}
	componentDidMount() {
		if(this.props.reloadServices) this.props.reloadServices();
		if (this.props.selectedService && !this.props.isEmpresa) this.getList();
		this.sendCustomEventGTM({});
	}
	componentDidUpdate(prevProps) {
		if(prevProps.selectedService !== this.props.selectedService) {
			if (prevProps.selectedService !== null) {
				this.getList();
			} else {
				if (this.props.selectedService && this.state.loaded) {
					this.getList();
					this.setState({loaded: false})
				}
			}
			this.sendCustomEventGTM({trigger:"interacion-seleccion-servicio"})
		} 
	}

	sendCustomEventGTM({trigger="visita", metadata={}}){
		const event = "mis-servicios-granel-historial-pedidos";
		const {client_address, client_city, client_cod, client_region_cod, client_street, client_id, client_number} = this.props.selectedService;
		const props = {client_address, client_city, client_cod, client_region_cod, client_street, client_id, client_number}; 

		TagManager.dataLayer({ 
			dataLayer:{ 
				event, 
				metadata: { trigger, ...props, ...metadata} 
			} 
		});
	}
	getList() {
		this.setState({loading: true, pedidos: null, pedidosMessage: "", showAddress: false});
		var orderNumber = null;
		var filterDays = null;
		const showAddress = this.state.searchType === "order_number";
		if(showAddress) {
			orderNumber = this.state.searchPedido;
		}
		if(this.state.searchType === "days") {
			filterDays = this.state.filterDays;
		}
		getGranelPedidos(this.props.selectedService.client_cod, filterDays, orderNumber, (error, result) => {
			this.setState({loading: false});

			if(error) return;
			if(result.status === "empty") return this.setState({ pedidosMessage: result.message});

			const pedidos = result.data.map((pedido)=> (
				{
					...pedido, 
					client_address: pedido.address,
					client_street: pedido.street,
					client_number: pedido.number,
					client_block: pedido.block,
					client_dept: pedido.dept,
					client_location: pedido.location
				}
			));
			
			this.setState({pedidos, showAddress});
		}, this.props.isEmpresa?"empresas":null);
	}
	renderContentModal(){
		document.body.style.overflow = "hidden";
		return(
			<iframe 
			title='iframe-content-info-track' 
			className="track-modal-iframe" 
			src={urls.track_pedidos+this.state.modal.code}>
			</iframe>
		);
	}
	cancelModal(){
		document.body.style.overflow = "";
		this.setState({ modal: {show:false}}, ()=> this.sendCustomEventGTM({trigger:"cta-consultar-cerrar"}));
	}
	render() {
		return (
			<Switch>
			<Route exact path="/mis-servicios/granel/pedidos">
			<ContentBox loading={this.state.loading === null ? true : this.state.loading}>
				<div className="title-client-container clearfix">
					<h1>Historial de Pedidos</h1>
					<div className="client-number">
						<ClientSelectGranel
							selected={this.props.selectedService}
							services={this.props.services}
							setSelectedService={this.props.setSelectedService}
							number_field={"client_cod"} />
					</div>
				</div>
				<div className="col-100 left d-flex justify-between margin-bottom-40">
					<div className="filter-container grid-column-3">
						<div className="position-relative">
							<select 
							value={this.state.searchType} 
							onChange={(e) => {
								const searchType = e.target.value;
								this.setState({ searchType }, ()=> this.sendCustomEventGTM({trigger:"select-tipo-busqueda", metadata:{inputValue: searchType}}))
							}}>
								<option value="days">Periodo</option>
								<option value="order_number">Número de pedido</option>
							</select>
						</div>
						{this.state.searchType==="order_number" ?
							<input 
							type="text" 
							placeholder={"N° de Pedido"} 
							value={this.state.searchPedido} 
							style={{flex: 1, marginRight: "20px"}}
							onChange={(e)=>{
								const searchPedido = e.target.value;
								this.setState({ searchPedido }, ()=> this.sendCustomEventGTM({trigger:"input-numero-pedido", metadata:{inputValue: searchPedido}}))
							}} />
							:
							<div className="position-relative">
								<select 
								value={this.state.filterDays} 
								onChange={(e) => {
									const filterDays = e.target.value;
									this.setState({ filterDays }, ()=> this.sendCustomEventGTM({trigger:"select-dias", metadata:{inputValue: filterDays}}))
								}}>
									<option value="30">Último mes</option>
									<option value="90">Últimos 3 meses</option>
									<option value="180">Últimos 6 meses</option>
									<option value="365">Últimos 12 meses</option>
								</select>
							</div>
						}
						<button 
						className="button orange" 
						onClick={() => {
							this.getList()
							this.sendCustomEventGTM({trigger:"cta-filtrar"})
						}}>
							Filtrar
						</button>
					</div>
				</div>
				<div className="table-container">
					<table className="table1">
						<thead>
							<tr>
								<td>Fecha del Pedido</td>
								<td>Número Pedido</td>
								<td>Litros Solicitados</td>
								<td>Fecha Programada</td>
								<td>Estado</td>
								{this.state.showAddress && <td>Dirección</td>}
								<td></td>
								<td></td>
								<td></td>
								<td>SEGUIMIENTO del pedido</td>
							</tr>							
						</thead>
						<tbody>
							{!this.state.pedidos?null:this.state.pedidos.map((pedido, i) => {
								var address = "";
								if(pedido.address && pedido.address.trim() !== "") address += pedido.address;
								if(pedido.commune && pedido.commune.trim() !== "") {
									if(address !== "") address += ", ";
									address += pedido.commune;
								}
								if(pedido.region && pedido.region.trim() !== "") {
									if(address !== "") address += ", ";									
									address += pedido.region;
								}
								var creationMoment = moment(pedido.creationDateTime, "DD.MM.YYYY - hh:mm");
							return(
							<tr key={pedido.orderNumber}>
								<td className="white-space-pre">{creationMoment.format("DD-MM-YYYY")}<br/>{creationMoment.format("HH:mm")}</td>
								<td>{pedido.orderNumber}</td>
								<td>{parseFloat(pedido.liters.replace(",", ".")).toLocaleString("de")}</td>
								<td className="white-space-pre">{moment(pedido.scheduledDate, "YYYY-MM-DD").format("DD-MM-YYYY")}</td>
								<td>{pedido.state}</td>
								{this.state.showAddress?<td>{address}</td>:null}
								<td>
									{pedido && pedido.claimDelay &&
									<div 
									className="linkA-container" 
									onClick={()=>{
										const reclamar_order = pedido;
										this.setState({ reclamar_order }, ()=> this.sendCustomEventGTM({trigger:"cta-no-recibi-pedido", metadata:{reclamar_order}}))
									}} >
										<a href={null}>No he recibido mi pedido</a>
									</div>}
								</td>
								<td>
									{pedido && (pedido.cancel_order || pedido.is_canceled) &&
									<div 
									className="linkA-container" 
									onClick={()=>{
										const anular_order = pedido;
										this.setState({ anular_order }, ()=> this.sendCustomEventGTM({trigger:"cta-anular", metadata:{anular_order}}))
									}}>
										<a  href={null}>Anular</a>
									</div>}
								</td>
								<td>
									<div className="linkA-container">
										<Link 
										to={"/mis-servicios/granel/pedidos/" + pedido.orderNumber}
										onClick={()=> {
											const {orderNumber} = pedido;
											this.sendCustomEventGTM({trigger:"cta-detalle", metadata:{orderNumber}})
										}}>
											Ver Detalle
										</Link>
									</div>
								</td>
								<td>
									<button 
									className="button orange"
									onClick={()=>{
										const {orderNumber} = pedido;
										this.setState({modal: {show:true, code: orderNumber}}, ()=> this.sendCustomEventGTM({trigger:"cta-consultar", metadata:{orderNumber}}));
									}} >
										Consultar
									</button>
								</td>
							</tr>
									);
								
							})}
						</tbody>
					</table>
					{!this.state.pedidos && <p>{this.state.pedidosMessage}</p>}
					{this.state.modal.show && 
					<ModalCampain 
					closeRight={true} 
					expandFull={true} 
					renderContent={()=>this.renderContentModal()} 
					cancel={()=>this.cancelModal()} 
					show={this.state.modal.show}
					/>
					}
				</div>
				{this.state.anular_order?<PopupPedidoAnular isEmpresa={this.props.isEmpresa} client={this.props.selectedService} order={this.state.anular_order} cancel={()=>this.setState({anular_order: null})} confirm={true||this.confirmModal.bind(this)} show={this.state.anular_order} reload_list={()=>{this.filter()}} business_line="housing"/>:null}
				{this.state.reclamar_order?<PopupPedidoReclamo isEmpresa={this.props.isEmpresa} order_number={this.state.reclamar_order?this.state.reclamar_order.orderNumber:null} client_cod={this.props.selectedService?this.props.selectedService.client_cod:null} cancel={()=>this.setState({reclamar_order: null})} confirm={null} hasClaim={this.state.reclamar_order?this.state.reclamar_order.hasClaim:false} show={this.state.reclamar_order}/>:null}
			</ContentBox>
			</Route>
			<Route path="/mis-servicios/granel/pedidos/:id"
      				render={(data)=> 
					<ServiciosGranelPedido isEmpresa={this.props.isEmpresa} pedido_id={data.match.params.id} />}>
            </Route>
		</Switch>
		);
	}
}
